<div class="p-col-12 p-grid p-jc-center">
  <div class="form-container p-card">
    <h2 i18n="register form header|Register form header@@register-form-header">Register</h2>
    <form class="p-fluid" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <div class="p-field">
        <label for="firstName" i18n="first name label|First name field label@@firstName-field-label">First Name</label>
        <input
          type="text"
          formControlName="firstName"
          pInputText
          [ngClass]="{ 'p-invalid': submitted && f.firstName.errors }"
        />
        <div *ngIf="submitted && f.firstName.errors" class="p-invalid">
          <div *ngIf="f.firstName.errors.required" i18n="field required error|Field is required@@field-required-error">Field is required</div>
        </div>
      </div>
      <div class="p-field">
        <label for="lastName" i18n="last name label|Last name field label@@lastName-field-label">Last Name</label>
        <input
          type="text"
          formControlName="lastName"
          pInputText
          [ngClass]="{ 'p-invalid': submitted && f.lastName.errors }"
        />
        <div *ngIf="submitted && f.lastName.errors" class="p-invalid">
          <div *ngIf="f.lastName.errors.required" i18n="field required error|Field is required@@field-required-error">Field is required</div>
        </div>
      </div>
      <div class="p-field">
        <label for="username" i18n="login field label|Login field label@@login-field-label">Login</label>
        <input
          type="username"
          formControlName="username"
          pInputText
          [ngClass]="{ 'p-invalid': submitted && f.username.errors }"
        />
        <div *ngIf="submitted && f.username.errors" class="p-invalid">
          <div *ngIf="f.username.errors.required" i18n="field required error|Field is required@@field-required-error">Field is required</div>
        </div>
      </div>
      <div class="p-field">
        <label for="password" i18n="password field label|Password field label@@password-field-label">Password</label>
        <input
          type="password"
          formControlName="password"
          pPassword
          [feedback]="false"
          [ngClass]="{ 'p-invalid': submitted && f.password.errors }"
        />
        <div *ngIf="submitted && f.password.errors" class="p-invalid">
          <div *ngIf="f.password.errors.required" i18n="field required error|Field is required@@field-required-error">Field is required</div>
          <div *ngIf="f.password.errors.minlength" i18n="minimum password length error|Minimum password length error@@minimum-password-length-error">Minimum password length is {{minLength}}</div>
        </div>
      </div>
      <div class="p-field">
        <label for="repeatPassword" i18n="repeat password field label|Repea password field label@@repeatPassword-field-label">Repeat password</label>
        <input
          type="password"
          formControlName="repeatPassword"
          pPassword
          [feedback]="false"
          [ngClass]="{ 'p-invalid': submitted && f.repeatPassword.errors }"
        />
        <div *ngIf="submitted && f.repeatPassword.errors" class="p-invalid">
          <div *ngIf="f.repeatPassword.errors.passwordDifferent" i18n="passwords differ error|Passwords must be identical@@passwordDifferent-error">Passwords must be indentical</div>
          <div *ngIf="f.repeatPassword.errors.required" i18n="field required error|Field is required@@field-required-error">Repeat password</div>
        </div>
      </div>
      <div class="p-field">
        <button *ngIf="!loading" pButton [disabled]="loading" i18n-label="register button|Register button@@register-button" label="Register"></button>
        <button *ngIf="loading" pButton [disabled]="loading" i18n-label="register button|Register button@@register-button" label="Register" icon="pi pi-spin pi-spinner" [iconPos]="'right'"></button>

        <button pButton i18n-label="cancel button|Cancel button@@cancel-button" label="Cancel" class="p-button-link" (click)="cancel()"></button>
      </div>
    </form>
  </div>
</div>
